<template>
    <article class="flex gap-4">
        <div :class="iconWrapperClass">
            <i :class="iconClass + ' h-5 w-auto text-white'"></i>
        </div>
        <div>
            <h3 class="font-semibold text-lg">{{ title }}</h3>
            <p class="text-slate-600 text-sm leading-6" v-html="text"></p>
        </div>
    </article>
</template>

<script>
export default {
    name: 'FeatureCard',
    props: {
        title: { type: String, required: true },
        text: { type: String, required: true },
        iconClass: { type: String, default: '' },
        iconWrapperClass: {
            type: String,
            default: 'shrink-0 h-10 w-10 rounded-full border bg-blue-dark grid place-items-center'
        }
    }
};
</script>
